import React, { useRef } from 'react';
var VeltActivityLogHeaderFilterContentItemIcon = function (props) {
    var defaultCondition = props.defaultCondition, isActive = props.isActive, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-activity-log-header-filter-content-item-icon", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "is-active": [true, false].includes(isActive) ? (isActive ? 'true' : 'false') : undefined }, children));
};
export default VeltActivityLogHeaderFilterContentItemIcon;
